import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Text, useStyleConfig} from '@chakra-ui/react'
import {Link as RouteLink} from 'react-router-dom'
import ChevronRightIcon from '../../icons/arrows/ChevronRight'
import useDamImage from '../../../custom-hooks/use-dam-image'
import {getGlobalLink} from '../../../utils/contentstack-utils'

const PlpGridCard = ({title, redirects, images, colSpan = 1, categoriesData}) => {
    const styles = useStyleConfig('PlpGridCard')

    const damImage = useDamImage(images)
    const {url, label, isAbsolute} = getGlobalLink(redirects, categoriesData)

    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: RouteLink,
              to: url,
          }

    return (
        <Flex
            {...styles.container}
            gridColumn={`span ${colSpan}`}
            background={
                damImage?.url
                    ? `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 21.28%, rgba(0, 0, 0, 0.70) 90.43%), url(${damImage.url}) lightgray 50% / cover no-repeat`
                    : 'none'
            }
        >
            <Text {...styles.title}>{title}</Text>
            {label && url && (
                <Button
                    {...buttonProps}
                    {...styles.button}
                    variant="inverse-icon-button"
                    rightIcon={<ChevronRightIcon />}
                >
                    {label}
                </Button>
            )}
        </Flex>
    )
}

PlpGridCard.propTypes = {
    title: PropTypes.string,
    images: PropTypes.object,
    redirects: PropTypes.object,
    categoriesData: PropTypes.object,
    colSpan: PropTypes.number,
}

export default PlpGridCard
